import React from "react";

export default function QuotationCategory() {
  return (
    <div>
      <h4 className="pages-h4">Quotation Category</h4>
    </div>
  );
}
